import type {
  TestAgentIdentityConnectionRequest,
  TestAgentEnvironmentConnectionResult,
} from "@/api/temp/AgentEstateService";
import { isInvestmentBankingDemo } from "@/libs/investmentBankingDemo";

export function validateDemoIdentity(
  params: TestAgentIdentityConnectionRequest,
): TestAgentEnvironmentConnectionResult {
  if (!isInvestmentBankingDemo())
    return {
      success: false,
      message: "Okta is not available for this onboarding configuration.",
    };
  const valid =
    !params.reusedFromPlatformConnection &&
    /^[A-Za-z0-9][A-Za-z0-9._-]*$/.test(params.tenantId) &&
    /^[A-Za-z0-9_-]+$/.test(params.clientId) &&
    /^[\x21-\x7E]+$/.test(params.clientSecret);
  return valid
    ? {
        success: true,
        message:
          "Credential format validated. Authentication has not been verified.",
      }
    : {
        success: false,
        message:
          "Enter a tenant/domain and client ID using identifier characters, and a nonempty printable secret without whitespace.",
      };
}
